"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

interface RedirectToProps {
  href: string;
}

export function RedirectTo({ href }: RedirectToProps) {
  const router = useRouter();

  useEffect(() => {
    router.replace(href);
  }, [href, router]);

  return (
    <noscript>
      <meta httpEquiv="refresh" content={`0;url=${href}`} />
    </noscript>
  );
}
